<template>
  <div>
    <div class="ui-block">
      <div class="ui-block-title">
        <h6 class="title">Change your account email</h6>
      </div>
      <div class="ui-block-content">
        <!-- Change Email Form -->

        <form>
          <div class="row">
            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <SInput
                v-model="loggedUser.email"
                label="Current email"
                :disabled="true"
                type="email"
                required
              />
              <div class="text-center text-danger">{{ textCurrent }}</div>
            </div>
            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
              <SInput
                v-model="newEmail"
                label="New email"
                type="email"
                ref="firstInput"
                required
                data-cy="newEmailInput"
              />
              <div class="text-center text-danger">{{ textNewEmail }}</div>
            </div>

            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
              <SInput
                v-model="confirmNewEmail"
                label="Confirm new email"
                type="email"
                required
                data-cy="newEmailConfirmInput"
              />
              <div class="text-center text-danger">{{ textConfirmEmail }}</div>
            </div>

            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
              <SInput
                v-model="currentPassword"
                type="password"
                label="Confirm current password"
                required
                eyeToggle
                data-cy="formMailCurrentPasswordInput"
              />
              <div class="text-center text-danger">{{ textCurrentPassword }}</div>
            </div>

            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 update-btn">
              <div class="text-danger mb-1 text-center">{{ text }}</div>
              <SButton
                size="lg"
                text="CHANGE EMAIL"
                color=""
                class="full-width btn-blue"
                @button="sendChange"
                data-cy="formMailSendChange"
              />
            </div>
          </div>
        </form>

        <!-- ... end Change Email Form -->
      </div>
    </div>
    <Modal
      id="emailForm-warning"
      buttonName="OK"
      title="Change Email"
      ref="modal"
      @button="closeModal()"
      @hide="onModalClose()"
      >
      <div data-cy="modalChangeEmailResult">{{ response.result || response.error }}</div>
    </Modal>
  </div>
</template>

<script>
import SInput from "@/components/atoms/SInput";
import SButton from "@/components/atoms/SButton";
import Modal from "@/components/atoms/Modal";
import UserHelperVue from "../../mixins/UserHelper.vue";
export default {
  name: "FormEmail",
  mixins: [UserHelperVue],
  components: {
    SInput,
    SButton,
    Modal,
  },
  data() {
    return {
      currentEmail: "",
      currentPassword: "",
      newEmail: "",
      confirmNewEmail: "",
      text: "",
      textCurrent: "",
      textCurrentPassword: "",
      textNewEmail: "",
      textConfirmEmail: "",
      passwordTest: false,
      currentTest: false,
      both: false,
    };
  },
  methods: {
    async sendChange() {
      this.checkCurrentEmail();
      this.checkConfirmationEmail();
      this.checkPassword();
      if (this.both && this.currentTest && this.passwordTest) {
        await this.emailUpdate({ email: this.newEmail, password: this.currentPassword });
        $("#emailForm-warning").modal("show");
      }
    },
    closeModal() {
      this.$refs.modal.closeModal();
    },
    onModalClose() {
      this.currentEmail = this.loggedUser.email;
      this.currentPassword = "";
      if (this.currentEmail === this.newEmail) {
        this.newEmail = "";
        this.confirmNewEmail = "";
      }
    },
    validateEmail(email) {
      const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return re.test(String(email).toLowerCase());
    },
    checkCurrentEmail() {
      if (!this.validateEmail(this.currentEmail)) {
        this.textCurrent = "The current e-mail is not a valid one";
        this.currentTest = false;
        return false;
      }
      if (this.currentEmail !== this.loggedUser.email) {
        this.textCurrent = "This is not the current user email";
        this.currentTest = false;
        return false;
      }
      this.textCurrent = "";
      this.currentTest = true;
      return true;
    },
    checkConfirmationEmail() {
      if (!this.validateEmail(this.newEmail)) {
        this.textNewEmail = "'New email' is not a valid email";
        this.both = false;
        return false;
      } else {
        this.textNewEmail = "";
      }
      if (!this.validateEmail(this.confirmNewEmail)) {
        this.textConfirmEmail = "'Confirm new' email not a valid email";
        this.both = false;
        return false;
      } else {
        this.textConfirmEmail = "";
      }
      if (this.newEmail !== this.confirmNewEmail) {
        this.text = "Both, New Email and Confirm New Email, must be equal";
        this.both = false;
        return false;
      }
      this.text = "";
      this.both = true;
      return true;
    },
    checkPassword() {
      if (!this.currentPassword) {
        this.textCurrentPassword = "Enter the password to make the email change"
        this.passwordTest = false;
        return false;
      }
      this.passwordTest = true;
      return true;
    }
  },
};
</script>
